import React from 'react';
import { motion } from 'framer-motion';

const WebsitePreview = ({ site, onClick, delay = 0, className = '' }) => {
  // Website configurations based on actual websites
  const websites = {
    'discover-lehigh-valley': {
      url: 'www.discoverlehighvalley.com',
      title: 'Discover Lehigh Valley',
      color: '#1a3c7b', // Deep blue color from their site
      textColor: 'white',
      categoryText: 'Tourism Campaign',
      headerText: 'Discover Lehigh Valley',
      navItems: ['Things to Do', 'Attractions', 'Amusement Parks & Entertainment', 'Casino', 'Paranormal & Haunted'],
      logo: '/images/lehigh-valley-logo.png', // If available, otherwise we'll create text
    },
    'pa-gets-it-done': {
      url: 'pagetsdone.com',
      title: 'PA Gets It Done', 
      color: '#28623c', // Green color from the PA flag
      textColor: 'white',
      categoryText: 'Official Campaign',
      headerText: 'PA Gets It Done',
      navItems: [],
      logo: '/images/pa-logo.png', // If available, otherwise we'll create text
    }
  };

  const config = websites[site] || websites['discover-lehigh-valley'];
  
  // Add hover and click effects
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className={`relative rounded-lg overflow-hidden shadow-lg cursor-pointer ${className}`}
      onClick={onClick}
    >
      {/* Browser Chrome */}
      {site === 'discover-lehigh-valley' && (
        <>
          <div className="bg-darkCard rounded-t-lg p-1.5 flex items-center space-x-2">
            <div className="flex space-x-1.5 pl-2">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
            <div className="flex-1 mx-4">
              <div className="bg-darkBg rounded-md px-3 py-1 text-lightText/70 text-xs flex items-center">
                <span className="text-green-400 mr-2">●</span>
                discoverlehighvalley.com
              </div>
            </div>
          </div>
          
          {/* Content */}
          <div className="w-full bg-white relative">
            {/* Use the full website screenshot image */}
            <div className="w-full">
              <img 
                src="/images/discover lv website.PNG" 
                alt="Discover Lehigh Valley Website" 
                className="w-full h-auto"
              />
            </div>
            
            {/* Tourism Campaign overlay */}
            <div className="absolute bottom-0 left-0 p-3">
              <div className="text-primary text-[11px] font-medium">
                Tourism Campaign
              </div>
              <div className="text-lightText text-xl font-bold drop-shadow-md">
                Discover Lehigh Valley
              </div>
            </div>
          </div>
        </>
      )}
      
      {/* PA Gets It Done */}
      {site === 'pa-gets-it-done' && (
        <>
          <div className="bg-darkCard rounded-t-lg p-1.5 flex items-center space-x-2">
            <div className="flex space-x-1.5 pl-2">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
            <div className="flex-1 mx-4">
              <div className="bg-darkBg rounded-md px-3 py-1 text-lightText/70 text-xs flex items-center">
                <span className="text-green-400 mr-2">●</span>
                pagetsdone.com
              </div>
            </div>
          </div>
          
          {/* Content */}
          <div className="w-full bg-white relative">
            {/* Use the full website screenshot image */}
            <div className="w-full">
              <img 
                src="/images/Visit PA website.PNG" 
                alt="PA Gets It Done Website" 
                className="w-full h-auto"
              />
            </div>
            
            {/* Official Campaign overlay */}
            <div className="absolute bottom-0 left-0 p-3">
              <div className="text-primary text-[11px] font-medium mb-1">
                Official Campaign
              </div>
              <div className="text-lightText text-xl font-bold drop-shadow-md">
                PA Gets It Done
              </div>
            </div>
          </div>
        </>
      )}

      {/* Hover Overlay with gradient from bottom */}
      <div className="absolute inset-0 bg-gradient-to-t from-darkBg/70 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-8">
        <div className="text-center">
          <span className="text-lightText font-bold text-lg">
            {site === 'discover-lehigh-valley' ? 'Discover Lehigh Valley' : 'PA Gets It Done'}
          </span>
          <p className="text-lightText/90 text-sm mt-1">Click to view project</p>
        </div>
      </div>
    </motion.div>
  );
};

export default WebsitePreview; 